export const YOUTUBE_PATH = 'https://www.youtube.com/results?search_query=';
